import { FC, ReactNode } from 'react';

import styles from './AuthContainer.module.sass';

interface AuthContainerProps {
  title?: string | null;
  badge?: string | null;
  note?: ReactNode;
  description?: ReactNode;
  alert?: ReactNode;
  fields?: ReactNode;
  buttons?: ReactNode;
}

const AuthContainer: FC<AuthContainerProps> = ({
  title,
  badge,
  note,
  description,
  alert,
  fields,
  buttons,
}) => {
  return (
    <>
      {(title || description) && (
        <div className={styles.head}>
          {badge && <div className={styles.badge}>{badge}</div>}
          {title && <h1 className={styles.title}>{title}</h1>}
          {note && <div className={styles.note}>{note}</div>}
          {description && (
            <div className={styles.description}>{description}</div>
          )}
          {alert && <div className={styles.alert}>{alert}</div>}
        </div>
      )}
      {fields && <div className={styles.fields}>{fields}</div>}
      {buttons && <div className={styles.buttons}>{buttons}</div>}
    </>
  );
};

export default AuthContainer;
